import { getBaseMetaTitle } from '@/environments'

const Main = () => import('./Main')

const route = {
  path: '/',
  name: 'home',
  meta: {
    title: `Home - ${getBaseMetaTitle}`
  },
  component: Main
}

export default route
